import graphql__1fe343211f360f3a5aee from "./__generated__/ContributionFormRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";

import AppQueryRenderer from "../AppQueryRenderer";
import ModalErrorBoundary from "../ErrorBoundaries/ModalErrorBoundary";
import ModalLoader from "../Modals/ModalLoader";
import ContributionForm from "../ParticipativeModule/ContributionForm";
import { useMapContributionDetails } from "../Utils/map";

const ContributionFormRoute = props => {
  const params = useParams();
  const participativeModuleSlug =
    props.participativeModuleSlug || params.participativeModuleSlug;
  const mapContributionDetails = useMapContributionDetails();

  const variables = {
    participativeModuleSlug,
    mapContributionDetails
  };

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={ContributionFormRouteQuery}
      variables={variables}
      additionalProps={props}
      component={ContributionForm}
      loader={<ModalLoader />}
      ErrorBoundary={ModalErrorBoundary}
      // Ensure that the contribution object is always reloaded from the server when the
      // route is accessed, to avoid a completed contribution to be used from the store
      // which can prevent the form to be accessed by the user after he already submitted
      // a contribution.
      fetchPolicy="network-only"
    />
  );
};

const ContributionFormRouteQuery = graphql__1fe343211f360f3a5aee;

export default ContributionFormRoute;
